import { makeRequest } from 'utils/requestLogger';

export default (live_discussion_id) =>
  makeRequest(
    'delete',
    `/api/live_discussions/${live_discussion_id}/moderator`
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/resetModerator.js